import React from 'react';
import { ButtonWithText } from '../../../../atoms/Buttons/ButtonWithText';
import { AvatarChoiceBlock } from '../../../../molecules/Blocks/AvatarChoiceBlock';
import { useSelector } from 'react-redux';
import { AppState } from '../../../../../store/reducers';
import { FeatureContainer } from '../../../../molecules/Containers/FeatureContainer';
import useStyle from './avatars.style';

interface AvatarsChoiceProps {
  previous: () => void;
}
export const AvatarsChoice = ({ previous }: AvatarsChoiceProps) => {
  const classes = useStyle();
  const user = useSelector((state: AppState) => state.user);
  return (
    <div className={classes.root}>
      <div className={classes.headintro}>
        <p>Sélectionne un avatar</p>
      </div>
      <FeatureContainer>
        <p>Pour commencer le challenge, choisis un avatar.</p>
        <p>
          Tu pourras modifier celui-ci au fil du temps. Plus tu auras des bons
          résultats, plus tu auras d'avatars. On te réserve quelques surprises.
          <span role="img" aria-label="check">
            ✅
          </span>
        </p>
      </FeatureContainer>
      <div className={classes.gap}>
        <AvatarChoiceBlock userid={user.id} visibleTitle={false} />
        <div className={classes.buttons}>
          <ButtonWithText content="Précédent" onClick={previous} />
        </div>
      </div>
    </div>
  );
};
